import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=18678c5c"
import script from "./Countdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Countdown.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports